import { render, staticRenderFns } from "./AddEditSetting.vue?vue&type=template&id=72e584c4"
import script from "./AddEditSetting.vue?vue&type=script&lang=js"
export * from "./AddEditSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports